import _extends from "@babel/runtime/helpers/esm/extends";
import { EModel, fieldsIBaseModelWithUser } from '@lumahealthhq/ui-model-types';

// Enum exports from the model repository
export var ELumaPayChargeStatus = /*#__PURE__*/function (ELumaPayChargeStatus) {
  ELumaPayChargeStatus["Planned"] = "planned";
  ELumaPayChargeStatus["Billable"] = "billable";
  ELumaPayChargeStatus["Billed"] = "billed";
  ELumaPayChargeStatus["Aborted"] = "aborted";
  return ELumaPayChargeStatus;
}({});
export var ELumaPayChargeType = /*#__PURE__*/function (ELumaPayChargeType) {
  ELumaPayChargeType["Copay"] = "copay";
  ELumaPayChargeType["Balance"] = "balance";
  ELumaPayChargeType["CustomAppointmentCharge"] = "custom-appointment-charge";
  return ELumaPayChargeType;
}({});
export var ELumaPayChargeSource = /*#__PURE__*/function (ELumaPayChargeSource) {
  ELumaPayChargeSource["Manual"] = "manual";
  ELumaPayChargeSource["Integrator"] = "integrator";
  ELumaPayChargeSource["InsuranceVerification"] = "insurance-verification";
  return ELumaPayChargeSource;
}({});
export var ELumaPayChargePaymentStatus = /*#__PURE__*/function (ELumaPayChargePaymentStatus) {
  ELumaPayChargePaymentStatus["Pending"] = "pending";
  ELumaPayChargePaymentStatus["NotPaid"] = "not-paid";
  ELumaPayChargePaymentStatus["Paid"] = "paid";
  ELumaPayChargePaymentStatus["PartiallyPaid"] = "partially-paid";
  return ELumaPayChargePaymentStatus;
}({});
/**
 * Fields and their types for the luma-pay-charge model.
 */
export var fieldsLumaPayCharge = _extends({}, fieldsIBaseModelWithUser, {
  amount: {
    type: 'Number'
  },
  amountPaid: {
    type: 'Number'
  },
  currency: {
    type: 'Text'
  },
  status: {
    type: 'Option',
    values: ELumaPayChargeStatus
  },
  lastStatusUpdatedAt: {
    type: 'Date'
  },
  lastStatusUpdatedBy: {
    type: 'ID',
    ref: EModel.User
  },
  type: {
    type: 'Option',
    values: ELumaPayChargeType
  },
  source: {
    type: 'Option',
    values: ELumaPayChargeSource
  },
  paymentStatus: {
    type: 'Option',
    values: ELumaPayChargePaymentStatus
  },
  description: {
    type: 'Text'
  },
  reason: {
    type: 'Text'
  },
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  insuranceVerification: {
    type: 'ID',
    ref: EModel.InsuranceVerification
  },
  insurance: {
    type: 'ID',
    ref: EModel.Insurance
  },
  metadata: {
    type: 'Object'
  }
});